$(function(){
  // console.clear();
  console.log('Text Switch Work Started...');

  let switches = document.querySelectorAll('.itemSwitch');

  switches.forEach(function(item){
    let itemSwitch = item.lastChild.firstChild,
        itemInput = item.nextSibling.firstChild.firstChild,
        itemColors = item.nextSibling.lastChild.firstChild,
        itemHiddenInput = item.nextSibling.firstChild.firstChild.nextSibling;

    $(itemSwitch).on('click', function(){
       console.log(this);

      function itemResult(item) {
        let originalOption = item.element;
        if(!$(originalOption).data('image')) {
          return $('<div class="select2-item-result-no_img">' + item.text + '</div>');
        } else {
          return $('<div class="select2-item-result-container">' +
                      '<img src="' + $(originalOption).data('image') + '">' +
                      '<div class="info">' +
                        '<div class="title">' + item.text + '</div>' +
                        '<div class="specs">' + $(originalOption).data('specs') + '</div>' +
                      '</div>' +
                   '</div>');
        }
      }

      function itemSelect(item) {
        return $('<span>' + item.text + '</span>');
      }

      if(this.checked){
        console.log('Box is checked');
        console.log(switches);

        $('.itemOption').select2({
          templateSelection: itemSelect,
          templateResult: itemResult,
          width: '100%'
        }).on('change', function(e) {
          // Access to full data
          // console.log($(this).select2('data'));
        }); //$('.itemOption').select2({ END

        console.log(itemInput); //Text Input
        console.log(itemColors); //Color List
        console.log(itemHiddenInput); //Text Input HIDDEN

        $(item.nextElementSibling).show();
        $(itemInput).attr('required', '').removeAttr('disabled');
        $(itemColors).attr('required', '').removeAttr('disabled');
        $(itemHiddenInput).removeAttr('disabled');
      } else {
        $(item.nextElementSibling).hide();
        $(itemInput).removeAttr('required').attr('disabled', '');
        $(itemColors).removeAttr('required').attr('disabled', '');
        $(itemHiddenInput).attr('disabled', '');

      } //if(this.checked){ END
        });//$(item.lastElementChild.firstElementChild).on('click', function(){ END
      }); //matches.forEach(function(item){ END

}); //$(function(){ END
